/**
 * @packageDocumentation
 * @module      UserLoggedInEvent.ts
 * @description A custom event that is fired when a user successfully logs in.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
/**
 * A custom event that is fired when a user successfully logs in.
 */
export class UserLoggedInEvent extends CustomEvent {
    /** Constructor. */
    constructor() {
        super(UserLoggedInEvent.eventName, {
            bubbles: true,
            composed: true,
            detail: '' // For details about the newly logged-in user, consult the LoggedInUser class.
        });
    }
}
/** The name of the event. */
UserLoggedInEvent.eventName = "userLoggedIn";
//# sourceMappingURL=UserLoggedInEvent.js.map